import type { EmployeeExecutionBlocker } from 'src/api/generated';

/** Business-facing outcomes displayed for an AI Agent execution. */
export const ExecutionOutcome = {
  COMPLETED: 'completed',
  FAILED: 'failed',
  RUNNING: 'running',
  BLOCKED: 'blocked',
  UNKNOWN: 'unknown',
} as const;

/** Business-facing execution outcome. */
export type ExecutionOutcomeValue =
  (typeof ExecutionOutcome)[keyof typeof ExecutionOutcome];

/** Sanitized blocker fields supported by the execution index. */
export interface ExecutionBlockerPresentation {
  /** Structured blocker contract returned by the API. */
  structured?: EmployeeExecutionBlocker;
  /** User-facing blocker reason. */
  reason?: string;
}
